var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46289 17.2275C6.96265 17.1218 10.0075 17.1219 10.5088 17.2275C10.9361 17.3262 11.3983 17.5572 11.3984 18.0605C11.3736 18.54 11.0927 18.9654 10.7041 19.2354C10.2002 19.6281 9.60841 19.8772 8.99023 19.9668C8.64848 20.0111 8.31226 20.0121 7.98242 19.9668C7.36344 19.8771 6.7723 19.628 6.26953 19.2344C5.87994 18.9655 5.59809 18.54 5.57324 18.0605C5.57342 17.5572 6.03567 17.3262 6.46289 17.2275ZM8.54492 0C10.6251 0 12.7505 0.987354 14.0127 2.625C14.8314 3.67935 15.207 4.73275 15.207 6.37012V6.7959C15.207 8.05181 15.5391 8.79246 16.2695 9.64551C16.8231 10.274 17 11.0808 17 11.9561C17 12.8302 16.713 13.6602 16.1377 14.334C15.3844 15.1417 14.3216 15.6574 13.2373 15.7471C11.6662 15.881 10.094 15.9941 8.50098 15.9941C6.90682 15.9941 5.33497 15.9263 3.76367 15.7471C2.6784 15.6574 1.61562 15.1417 0.863281 14.334C0.287933 13.6602 7.33571e-06 12.8302 0 11.9561C0 11.0808 0.177882 10.274 0.730469 9.64551C1.48379 8.79246 1.79395 8.05181 1.79395 6.7959V6.37012C1.79398 4.68826 2.21351 3.58834 3.07715 2.51172C4.36123 0.94165 6.4197 0 8.45605 0H8.54492Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d0902945f94fbb12ea38211dd879df34.svg";
export { ForwardRef as ReactComponent };